import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { CmsService } from '../../../core/services/cms.service';
import * as _ from 'lodash';
import { CmsContent } from '../../../shared/models/cms';

@Component({
  selector: 'generic-popup',
  templateUrl: './generic-popup.component.html',
  styleUrls: ['./generic-popup.component.css']
})
export class GenericPopupComponent implements OnInit {

  genericPopupData: CmsContent;
  readonly config = {
    loading: true,
  };
  private timeout = null;

  constructor( 
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<GenericPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CmsContent,
    private cmsService: CmsService) { }

  ngOnInit() {
    this.genericPopupData = this.data;
    this.init();
  }

  private init() {
    this.timeout = setTimeout(() => {
      this.config.loading = false;
      clearTimeout(this.timeout);
    }, 1000);
  }

  onImageLoadError() {
    this.config.loading = false;
    this.genericPopupData.contentStructureJson.mediaUrl = "NO_IMAGE_URL";
  }
  
  cmsMediaClick(cmsContentLinkObj: any) {
    if (!_.isEmpty(cmsContentLinkObj)) {
      this.cmsService.redirectBasedOnLinkType(cmsContentLinkObj);
    }
  }

  closeDialog() {
    this.dialogRef.close('close');
  }

}
